import React from "react";

export const inputCls =
  "w-full rounded-lg border bg-transparent px-3 py-2 text-sm outline-none focus:border-[color:var(--nq-gold)]";
export const borderStyle = { borderColor: "rgba(255,255,255,0.14)" };

export function AdminHeader({ title, subtitle, children }) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        <h1 className="text-2xl font-bold md:text-3xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-[color:var(--nq-stone)]">{subtitle}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
    </div>
  );
}

export function Field({ label, children, hint, as: Tag = "label" }) {
  return (
    <Tag className="block">
      <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-[color:var(--nq-stone)]">
        {label}
      </span>
      {children}
      {hint && <span className="mt-1 block text-xs text-[color:var(--nq-stone)]">{hint}</span>}
    </Tag>
  );
}

export function Panel({ children, className = "", ...rest }) {
  return <div className={`card-nq p-5 ${className}`} {...rest}>{children}</div>;
}

export function Table({ head = [], children }) {
  return (
    <div className="card-nq overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b" style={{ borderColor: "rgba(255,255,255,0.1)" }}>
            {head.map((h) => (
              <th
                key={h}
                className="whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider gold-text"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

export function Row({ children, testid }) {
  return (
    <tr
      className="border-b transition last:border-0 hover:bg-white/[0.03]"
      style={{ borderColor: "rgba(255,255,255,0.06)" }}
      data-testid={testid}
    >
      {children}
    </tr>
  );
}

export function Badge({ children, tone = "neutral", ...rest }) {
  const tones = {
    neutral: { background: "rgba(255,255,255,0.08)", color: "var(--nq-sand)" },
    green: { background: "rgba(31,107,58,0.35)", color: "var(--nq-sand)" },
    gold: { background: "var(--nq-gold)", color: "var(--nq-black)" },
    red: { background: "rgba(200,60,50,0.28)", color: "#ffd9d5" },
  };
  return (
    <span
      className="inline-block whitespace-nowrap rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider"
      style={tones[tone] || tones.neutral}
      {...rest}
    >
      {children}
    </span>
  );
}

export function StatCard({ label, value, icon: Icon, tone = "gold" }) {
  return (
    <div className="card-nq flex items-center gap-4 p-5">
      <div
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg"
        style={{
          background: tone === "gold" ? "rgba(198,162,74,0.14)" : "rgba(31,107,58,0.2)",
        }}
      >
        {Icon && <Icon className="h-5 w-5 gold-text" />}
      </div>
      <div className="min-w-0">
        <p className="text-2xl font-bold leading-none">{value}</p>
        <p className="mt-1 truncate text-xs text-[color:var(--nq-stone)]">{label}</p>
      </div>
    </div>
  );
}
